import {Injectable, InjectionToken} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {IAuditInterface} from "../../../../global/audit.interface";
import {
    PlaybookGuidelineStatusEnum
} from "./playbook-list/plyabbok-guideline-run-tile/playbook-guideline-run-tile.component";


export interface ICreateNewPayloadRunResponseDTO {
    created_at: string;
    errors: null;
    id: number;
    playbook: IPlaybookDTO;
    playbook_id: number;
    playbook_run_results: IPlaybookRunResultDTO[];
    runnable: IRunnableDTO;
    runnable_id: number;
    runnable_type: string;
    status: string;
    updated_at: string;
    user_id: number;
    workspace_id: number;
}

export interface IPlaybookDTO {
    color?: string;
    created_at?: Date;
    id?: number;
    name?: string;
    playbook_category_id?: number;
    playbook_guidelines: IPlaybookGuidelineDTO[];
    status?: string;
    updated_at?: Date;
}

export interface IPlaybookGuidelineDTO {
    content: string;
    created_at?: Date;
    deleted_at: Date | null;
    id: number;
    order: number;
    playbook_id: number;
    updated_at?: Date;
    user_id: number;
    workspace_id: number;
}

export interface IPlaybookRunResultDTO {
    created_at: string;
    errors: null;
    id: number;
    playbook_guideline: IPlaybookGuidelineDTO;
    playbook_guideline_id: number;
    playbook_run_id: number;
    reason: string;
    reference: string;
    status: PlaybookGuidelineStatusEnum;
    suggestion: string;
    updated_at: string;
    user_id: number;
    workspace_id: number;
}

export interface IRunnableDTO {
    allow_chat: number;
    allow_forward: number;
    attach_video: number;
    category_id: null;
    confirmation_message: null;
    content: string;
    created_at: string;
    created_via: string;
    crm_data: null;
    deleted_at: null;
    dk_password: null;
    dk_password_hint: null;
    dk_send_via_sms: number;
    dk_type: string;
    document_key: number;
    document_number: string;
    document_price: number;
    document_type_id: number;
    due_date: string;
    eform_message: null;
    folders_id: null;
    id: number;
    invitation_message: null;
    is_uploaded: number;
    language: string;
    name: string;
    pdf_path: null;
    recurring: number;
    reminder_date: null;
    save_to_folder: number;
    signing_deadline: null;
    signing_reminder: null;
    status: string;
    status_before_expire: null;
    status_updated_at: string;
    status_updated_manually: number;
    template_id: number;
    thumbnail: string;
    timezone: null;
    type: string;
    updated_at: string;
    user_id: number;
    video_title: null;
    video_type: string;
    video_url: null;
    visibility: string;
    visible_name: string;
    workspace_id: number;
}



export interface ICreateNewPayloadRun {
    id: number;
    playbook_id:number;
}

export enum PlaybookRunContextEnum{
    DOCUMENT = 'DOCUMENT',
    TEMPLATE= `TEMPLATE`,
}

export interface IPlaybookRunsListDTO extends IAuditInterface{
    errors?:        string;
    id?:            number;
    playbook_id?:   number;
    runnable_id?:   number;
    runnable_type?: string;
    status?:        string;
    user_id?:       number;
    workspace_id?:  number;

    playbook_run_results:IPlaybookRunResultDTO[]
}

export interface ICommonRunPlaybookApiService {
    getSpecificPlaybookRunById(id: number): Observable<IPlaybookRunsListDTO>;
}

export interface IRunPlaybookApiService extends ICommonRunPlaybookApiService{
    runPlaybook(payload: ICreateNewPayloadRun): Observable<ICreateNewPayloadRunResponseDTO>;
    deletePlaybookRun(id: number): Observable<void>;
    getPlaybookRunForById(id: number): Observable<IPlaybookRunsListDTO[]>;
}


export const PlaybookRunContextToken = new InjectionToken<PlaybookRunContextEnum>('PlaybookRunContextToken');
export const RunPlaybookApiServiceToken = new InjectionToken<IRunPlaybookApiService>('RunPlaybookApiServiceToken');

@Injectable({
    providedIn:'any'
})
export class CommonPlaybookRunApiService implements ICommonRunPlaybookApiService {
    constructor(protected _httpClient: HttpClient) {
    }

    getSpecificPlaybookRunById(id: number): Observable<IPlaybookRunsListDTO>{
        return this._httpClient.get<IPlaybookRunsListDTO>(`legalhub/playbook-runs/${id}`);
    }

    deletePlaybookRun(id: number): Observable<any>{
        return this._httpClient.delete(`legalhub/playbook-runs/${id}`);
    }

}

@Injectable({
    providedIn:'any'
})
export class DocumentPlaybookRunApiService extends CommonPlaybookRunApiService implements IRunPlaybookApiService{
    constructor(_httpClient: HttpClient) {
        super(_httpClient);
    }

    runPlaybook(payload:ICreateNewPayloadRun):Observable<ICreateNewPayloadRunResponseDTO>    {
        return this._httpClient.post<ICreateNewPayloadRunResponseDTO>(`legalhub/playbook-runs`,
            {
                document_id: payload.id,
                playbook_id: payload.playbook_id
            });
    }

    getPlaybookRunForById(id:number):Observable<IPlaybookRunsListDTO[]>{
        return this._httpClient.get<IPlaybookRunsListDTO[]>(`legalhub/playbook-runs/documents/${id}`);
    }
}

@Injectable({
    providedIn:'any'
})
export class TemplatePlaybookRunApiService extends CommonPlaybookRunApiService implements IRunPlaybookApiService{
    constructor(_httpClient: HttpClient) {
        super(_httpClient);
    }


    runPlaybook(payload:ICreateNewPayloadRun):Observable<ICreateNewPayloadRunResponseDTO>    {
        return this._httpClient.post<ICreateNewPayloadRunResponseDTO>(`legalhub/playbook-runs`,
            {
                template_id: payload.id,
                playbook_id: payload.playbook_id
            });
    }

    getPlaybookRunForById(id:number):Observable<IPlaybookRunsListDTO[]>{
        return this._httpClient.get<IPlaybookRunsListDTO[]>(`legalhub/playbook-runs/templates/${id}`);
    }

}
